import { Component, Input, ViewChild, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TreeViewComponent } from '@app/common-codes/components/nested-components/tree-view/tree-view.component';
import { TreeNode } from '@app/common-codes/components/nested-components/tree-node/tree-node.component';
import { JsonPipe } from '@angular/common';
import { FeatureMediatorComponent } from '@app/common-codes/components/feature-med-components/FeatureMediatorComponent';
import { Client } from '@app/common-codes/models/matwins-manager/Client.model';
import { RoleListComponent } from '../role/role-list/role-list.component';
import { CurrentTenantService } from '@app/common-codes/services/CurrentTenantService';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { DependencyInjectionProvider, EntityConstructor } from '@app/common-codes/services/DependecyInjection.provider';
import { LookupService } from '@app/common-codes/services/LookupService';
import { DataService } from '@app/common-codes/services/DataService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { FormsModule } from '@angular/forms';
import { StructuredDataRequest } from '@app/common-codes/_DTOs/IStructuredData';
import { PaginatedResponse } from '@app/common-codes/_DTOs/IPaginaterResponse';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { ActivatedRoute } from '@angular/router';
import { AuthentificationService } from '@app/common-codes/services/authentification.service';
import { GenericComponent } from '@app/common-codes/components/_base/GenericComponent';
import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { PermissionsService } from '@app/common-codes/services/Permissions.service';



@Component({
  selector: 'app-root',
  standalone: true,
  imports: [FormsModule, RoleListComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './permission-tenant.component.html',
})
export class PermissionTenantComponent extends GenericComponent<Client> implements OnInit {
  override Editable: boolean = true;
  override ComponentEntityClass = Client;
  override entityMetaData: IEntityMetaData = new Client().GetType();
  override Skin: IStaticStylesConfig = MatwinsSkins.V1;

  roleType: 'tenant' | 'manager' = 'tenant'; // valeur par défaut

  @ViewChild('roleList') roleList!: RoleListComponent;
  clientService: DataService<Client>;
  clients!: Client[];
  currentClient?: Client;


  public override get RequiredPermissions(): string[] {

    let permissions = [];
    let namespace = this.entityMetaData.Namespace ? `${this.entityMetaData.Namespace}.` : '';
    permissions.push(`Permissions.Entities.${namespace}${this.entityMetaData.EntityName}.Read`);

    return permissions;
  }
  public override get HasRequiredPermissions(): boolean {
    return this.permissionsService.UserHasAllPermissions(this.RequiredPermissions);
  }


  constructor(
    translationService: TranslationService,
    private permissionsService: PermissionsService,
    private varsService: MatwinsVariablesService,
    private authenticationService: AuthentificationService,
    private di: DependencyInjectionProvider,
    private tenantService: CurrentTenantService,
    private route: ActivatedRoute // Inject ActivatedRoute   
  ) {
    super();

    this.clientService = this.di.getOrCreateDataService(Client);
  }


  override ngOnInit() {
    super.ngOnInit();
    // Récupérer le paramètre de l'URL
    this.route.paramMap.subscribe(async params => {
      const roleTypeParam = params.get('roleType');
      const next: 'tenant' | 'manager' = roleTypeParam === 'manager' ? 'manager' : 'tenant';
      await this.onRoleTypeChange(next);

    });
    // if (this.roleType === 'tenant') {
    //   const params: any = {
    //     page: 1,
    //     size: null,
    //     search: null,
    //     sortBy: null,
    //     sortOrder: 'asc',
    //     searchColumns: null
    //   };
    //   this.clients = (await this.clientService.execute<PaginatedResponse<Client>>("Post", "role", params))?.items ?? [];
    //   this.currentClient = this.clients.find(c => c.prefix === this.authenticationService.currentUser?.tenant);
    // }
  }

  private async onRoleTypeChange(roleType: 'tenant' | 'manager') {
    this.roleType = roleType;
    // reset UI state
    this.currentClient = undefined;
    this.clients = [];
    if (this.roleType === 'tenant') {
      const params: any = {
        page: 1,
        size: null,
        search: null,
        sortBy: null,
        sortOrder: 'asc',
        searchColumns: null
      };
      this.clients = (await this.clientService.execute<PaginatedResponse<Client>>("Post", "role", params))?.items ?? [];
      this.currentClient = this.clients.find(c => c.id === this.authenticationService.currentUser?.managerClientId);

    }

  }

  // Binder les événements et données directement au mediator (soulagé de la logique computed)
  onClientSelected(client: Client) {

    this.currentClient = client;

    this.tenantService.currentClientId.set(client?.id || '');
    this.varsService.setClientId(client?.id || null);

    LookupService.StoragePage = client?.relatedTenant?.prefix || "all";
    // Logique specifique au feature (non-interactive, comme update de services)
    this.tenantService.currentTenant.set(client?.relatedTenant ?? null);

    this.varsService.tenantPrefix = this.currentClient?.prefix;
    this.varsService.tenantPrefixChanged$.set(this.currentClient?.prefix);
    if (this.roleList) {

      const params: StructuredDataRequest = {
        pageNumber: 1,
        pageSize: this.roleList.listView()?.pageSize() ?? 5,
        search: this.roleList?.searchTerm(),
        sortBy: this.roleList?.listView()?.sortBy(),
        sortOrder: this.roleList?.listView()?.sortOrder(),
        combinedSearchColumns: undefined,
        requiredLookups: undefined
      };

      this.roleList.performLoadData(params, 0, params.pageSize);  // ### performLoadData
    }
  }

}

